/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-return-assign */
/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, {
  useCallback, useContext, useEffect, useMemo, useRef,
  useState,
} from 'react';

import { AppContext } from '@powdr/context';
import { useWindowResize } from '@powdr/hooks';

import { OrderedShowcaseItem } from './components';
import {
  ShowcaseItems, StyledOrderedShowcase, ItemWrapper, IndicatorBar,
  IndicatorIcon,
  IndicatorIconWrapper,
  IndicatorText,
  BarElement,
} from './styles';

export const OrderedShowcase = ({
  className = '',
  activeShowcaseItem = 1,
  is5050,
  relationships,
}) => {
  const { isMobile } = useContext(AppContext);
  const indicatorRef = useRef();
  const itemRefs = useRef([]);
  const orderedShowcaseItems = useMemo(
    () => relationships?.showcaseItems.slice(0, (isMobile) ? 3 : 5) || [],
    [relationships, isMobile],
  );
  const trueActiveItem = activeShowcaseItem - 1; // make active item zero indexed
  const updateIndicatorPosition = useCallback(() => {
    const activeEl = itemRefs.current[trueActiveItem];
    const indicatorEl = indicatorRef.current;

    if (!activeEl || !indicatorEl) return;

    const parentEl = indicatorEl.offsetParent;
    const itemRect = activeEl.getBoundingClientRect();
    const parentRect = parentEl.getBoundingClientRect();

    const center = itemRect.left + itemRect.width / 2 - parentRect.left;
    indicatorEl.style.left = `${center}px`;
  }, [trueActiveItem]);

  useWindowResize(updateIndicatorPosition);

  useEffect(() => {
    updateIndicatorPosition();
  }, [trueActiveItem, orderedShowcaseItems, updateIndicatorPosition]);

  return (
    <StyledOrderedShowcase className={className}>
      <ShowcaseItems>
        {orderedShowcaseItems.map((item, idx) => (
          <ItemWrapper ref={(el) => (itemRefs.current[idx] = el)}>
            <OrderedShowcaseItem {...item} active={(idx === trueActiveItem)} />
          </ItemWrapper>
        ))}
      </ShowcaseItems>
      <IndicatorBar $is5050={is5050}>
        <BarElement />
        <IndicatorIconWrapper
          $activeItem={trueActiveItem}
          $totalItems={orderedShowcaseItems?.length}
          ref={indicatorRef}
          $is5050={is5050}
        >
          <IndicatorIcon name="loader-snowbird" $is5050={is5050} />
          <IndicatorText
            $is5050={is5050}
          >
            {orderedShowcaseItems[trueActiveItem].title}
          </IndicatorText>
        </IndicatorIconWrapper>
      </IndicatorBar>
    </StyledOrderedShowcase>
  );
};

OrderedShowcase.propTypes = {
  className: PropTypes.string,
  activeShowcaseItem: PropTypes.number,
  is5050: PropTypes.bool,
  relationships: PropTypes.shape({
    showcaseItems: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};
